import { Mail, Phone } from "lucide-react";
import { PageMeta } from "@/components/Layout";
import { Reveal } from "@/components/Reveal";
import { PageHero, SectionHeader } from "@/components/Section";
import { SEO, MEDIA, CONTACT } from "@/content/siteContent";

export default function Media() {
    return (
        <>
            <PageMeta title={SEO.media.title} description={SEO.media.description} />
            <PageHero eyebrow="Media Features" title={MEDIA.title} intro={MEDIA.body[0]} />

            <section className="surface-ivory py-20 sm:py-28" data-testid="media-archive">
                <div className="mx-auto max-w-4xl px-5 sm:px-8">
                    <SectionHeader eyebrow="The Archive" title="Verified coverage, gathered with care" />
                    <Reveal delay={0.1}>
                        <p className="body-copy mt-8 max-w-2xl">{MEDIA.body[1]}</p>
                    </Reveal>

                    {/* Holding state — no clippings supplied yet; layout ready for entries */}
                    <Reveal delay={0.15}>
                        <div
                            className="mt-12 flex flex-col items-center gap-4 rounded-sm border border-dashed border-[#A51C30]/35 bg-[#A51C30]/4 px-8 py-16 text-center"
                            data-testid="media-archive-empty"
                        >
                            <svg width="46" height="46" viewBox="0 0 44 44" fill="none" aria-hidden="true" className="text-[#A51C30]/45">
                                <circle cx="22" cy="22" r="20" stroke="currentColor" strokeWidth="1" />
                                <circle cx="22" cy="22" r="12" stroke="currentColor" strokeWidth="1" strokeDasharray="3 4" />
                            </svg>
                            <p className="font-display text-2xl font-semibold text-[#260910]">
                                The archive is being compiled
                            </p>
                            <p className="max-w-md text-sm font-light leading-relaxed text-[#2b1418]/65">
                                {MEDIA.archiveNote}
                            </p>
                        </div>
                    </Reveal>
                </div>
            </section>

            <section className="surface-dark py-20 sm:py-28" data-testid="media-journalists">
                <div className="mx-auto max-w-4xl px-5 text-center sm:px-8">
                    <Reveal>
                        <p className="eyebrow">Press</p>
                        <hr className="gold-rule gold-rule--center mx-auto mt-4" aria-hidden="true" />
                        <h2 className="font-display mt-5 text-3xl font-semibold text-[#FFF5E6] sm:text-4xl">
                            {MEDIA.journalists.title}
                        </h2>
                        <p className="body-copy mx-auto mt-6 max-w-2xl text-[#FFF5E6]/70">
                            {MEDIA.journalists.body}
                        </p>
                    </Reveal>
                    <Reveal delay={0.15} className="mt-10 flex flex-wrap items-center justify-center gap-4">
                        <a href={`mailto:${CONTACT.email}?subject=Media%20enquiry`} className="btn btn-gold" data-testid="media-email-cta">
                            <Mail size={15} /> {CONTACT.email}
                        </a>
                        <a href={CONTACT.phoneHref} className="btn btn-outline" data-testid="media-phone-cta">
                            <Phone size={15} /> {CONTACT.phoneDisplay}
                        </a>
                    </Reveal>
                </div>
            </section>
        </>
    );
}
